// sort-imports-ignore
import { IonApp, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { AppProviders } from '@/providers';
import { AppLayout } from '@/layouts';

/* Ionic CSS */
import '@ionic/react/css/core.css';
import '@ionic/react/css/display.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/padding.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/typography.css';

/* Third-party CSS */
import 'react-responsive-carousel/lib/styles/carousel.min.css';

/* Theme CSS */
import '@/theme/animations.css';
import '@/theme/fonts.css';
import '@/theme/ionic.css';
import '@/theme/scrollbar.css';
import '@/theme/variables.css';

setupIonicReact({
  mode: 'ios'
});

const App: React.FC = () => (
  <IonApp>
    <IonReactRouter>
      <AppProviders>
        <AppLayout />
      </AppProviders>
    </IonReactRouter>
  </IonApp>
);
export default App;
